var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1920 1920",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#8c4bd4;}.cls-2{fill:url(#Gradiente_sem_nome_18);}.cls-3{fill:url(#Gradiente_sem_nome_18-2);}.cls-4{fill:url(#Gradiente_sem_nome_18-3);}\n        "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_18",
    x1: 281.35,
    y1: 962.86,
    x2: 922.48,
    y2: 962.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5a81e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#a839f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cf87f9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_18-2",
    x1: 995.06,
    y1: 769.4,
    x2: 1294.15,
    y2: 769.4,
    xlinkHref: "#Gradiente_sem_nome_18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_18-3",
    x1: 593.82,
    y1: 960.46,
    x2: 1634.28,
    y2: 960.46,
    xlinkHref: "#Gradiente_sem_nome_18"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo_IconInfinito",
    "data-name": "Logo IconInfinito"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1750.27,626a861.24,861.24,0,0,0-395.68-427.95q-29.77-15.48-60.88-28.6a857.18,857.18,0,0,0-668,0q-32.51,13.72-63.59,30a858.58,858.58,0,0,0,7.3,1524.87q27.57,14.07,56.29,26.21a857.5,857.5,0,0,0,668,0q31.11-13.12,60.88-28.6A858.91,858.91,0,0,0,1750.27,626ZM1104,230.72c177.5,35,332.48,133.5,440.33,270.66H1263.56A845.47,845.47,0,0,0,1023,260.66,751.22,751.22,0,0,1,1104,230.72ZM593.82,749.19a757.33,757.33,0,0,1,47.79-123.83q11.92-24.25,25.46-47.54H1220.7q14.44,24.67,27.06,50.48a760.3,760.3,0,0,1,1.72,663.7q-11.91,24.63-25.48,48.27H666q-12.93-22.35-24.35-45.63a762.44,762.44,0,0,1-47.81-545.45ZM1169.5,501.38H717.9a768.46,768.46,0,0,1,224.89-200A768.14,768.14,0,0,1,1169.5,501.38Zm-375.85-266q35.16,11.2,68.79,25.7A844.63,844.63,0,0,0,624.07,501.38H375.14C478.56,369.85,625.28,273.92,793.65,235.36ZM321.19,1340.27a742.11,742.11,0,0,1,1.19-762.45H579.64q-13.15,25.65-24.55,52.34c-.48,1.09-1,2.19-1.42,3.3a828.93,828.93,0,0,0-46.28,145,848,848,0,0,0,0,363.08,828.93,828.93,0,0,0,46.28,145c.46,1.11.94,2.19,1.42,3.3q11,25.68,23.58,50.43ZM800.6,1686.2c-172.11-37.68-322.1-135.17-427-269.49h249.2a845,845,0,0,0,243.11,244.54Q834,1675.2,800.6,1686.2Zm145.48-65.69a768.14,768.14,0,0,1-229.62-203.8h457.38A768.1,768.1,0,0,1,946.08,1620.51Zm157.9,68.77a749.53,749.53,0,0,1-77.55-28.43,845.3,845.3,0,0,0,240.89-244.14H1545.8C1437.89,1554.87,1282.3,1654.08,1104,1689.28Zm494-348.61v-.4H1311.14q11.55-22.85,21.75-46.45c.78-1.8,1.54-3.58,2.31-5.37a831.55,831.55,0,0,0,43.3-132,847.43,847.43,0,0,0-1-393.38,831.66,831.66,0,0,0-42.29-127.73c-1.32-3.13-2.68-6.24-4-9.36q-10.76-24.54-22.93-48.19h288.83a742,742,0,0,1,.9,762.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M914.61,1043.83l7.87,159.31L882.56,1165l-9.23,12.37-26,26.62a334.12,334.12,0,0,1-205.66,90.67q-12.3.91-24.72.92a335.84,335.84,0,0,1-61.82-5.72C399.48,1260.76,281.35,1123.9,281.35,960S399.48,659.24,555.09,630.16c-.48,1.09-1,2.19-1.42,3.3a828.93,828.93,0,0,0-46.28,145,212.09,212.09,0,0,0,86.43,392.35A212,212,0,0,0,761.64,1115l17.58-18,13.39-18-37.51-35.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M995.06,807.15l44.41-59.64-.25-.21c1-1.21,2-2.32,3-3.5l2.63-3.54.27.2A334.51,334.51,0,0,1,1247.76,628.3,756.65,756.65,0,0,1,1294.15,748a211.38,211.38,0,0,0-155.22,72.71l-66.86,89.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1634.28,960c0,173.49-132.35,316.66-301.39,333.82a339.86,339.86,0,0,1-83.41-1.82c-80.09-11.67-152.78-51.73-206-114.14l-.23.18-7.49-9.58c-1-1.3-2-2.6-3.06-3.92l.29-.23L777.5,821.5a212.07,212.07,0,0,0-183.68-72.31,757.33,757.33,0,0,1,47.79-123.83A335,335,0,0,1,872.74,742.88l.09-.07,2.49,3.24,0,0L958,857l.3-.4,48.5,65.07-1.34-1,131.51,176.44A210.54,210.54,0,0,0,1295.26,1172c1.15,0,2.31,0,3.46,0a210.75,210.75,0,0,0,79.78-15.59c77.53-31.57,132.29-107.76,132.29-196.48,0-89.11-55.24-165.56-133.3-196.9a831.66,831.66,0,0,0-42.29-127.73c-1.32-3.13-2.68-6.24-4-9.36C1501,642.37,1634.28,785.93,1634.28,960Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f85a98bfa46d5cac5a0ff4bab3dbc63f.svg";
export { ForwardRef as ReactComponent };